<div class="edit-agent">
  <div>
    <div>{{ 'label.Name' | translate }}</div>
    <div>
      <input
        maxlength="30"
        type="text"
        [ngModel]="customerAgent && customerAgent.name"
        (ngModelChange)="customerAgent && (customerAgent.name = $event)"
      />
      <hr-field-state-marker [field]="field?.name"></hr-field-state-marker>
    </div>
  </div>
  <div>
    <div>{{ 'label.Surname' | translate }}</div>
    <div>
      <input
        maxlength="30"
        type="text"
        [ngModel]="customerAgent && customerAgent.surname"
        (ngModelChange)="customerAgent && (customerAgent.surname = $event)"
      />
      <hr-field-state-marker [field]="field?.surname"></hr-field-state-marker>
    </div>
  </div>
  <div>
    <div>{{ 'label.Email' | translate }}</div>
    <div>
      <input
        *ngIf="mode == Mode.Add"
        type="text"
        [ngModel]="customerAgent && customerAgent.email"
        (ngModelChange)="customerAgent && (customerAgent.email = $event)"
      />
      <div *ngIf="mode == Mode.Edit">
        <a href="mailto:{{ customerAgent?.email }}">{{
          customerAgent?.email
        }}</a>
      </div>
      <hr-field-state-marker [field]="field?.email"></hr-field-state-marker>
    </div>
  </div>
  <div class="phone-number">
    <div>{{ 'label.PhoneNumber' | translate }}</div>
    <div>
      <input
        maxlength="30"
        type="text"
        [ngModel]="customerAgent && customerAgent.phoneNumber"
        (ngModelChange)="customerAgent && (customerAgent.phoneNumber = $event)"
      />
      <hr-field-state-marker
        [field]="field?.phoneNumber"
      ></hr-field-state-marker>
      <span>{{ 'label.Extention' | translate }}</span>
      <input
        maxlength="5"
        type="text"
        class="ext"
        [ngModel]="customerAgent && customerAgent.phoneNumberExtension"
        (ngModelChange)="
          customerAgent && (customerAgent.phoneNumberExtension = $event)
        "
      />
      <hr-field-state-marker
        [field]="field?.phoneNumberExtension"
      ></hr-field-state-marker>
    </div>
  </div>
  <div>
    <div>{{ 'label.MobileNumber' | translate }}1</div>
    <div>
      <input
        maxlength="30"
        type="text"
        [ngModel]="customerAgent && customerAgent.mobilePhoneNumber"
        (ngModelChange)="
          customerAgent && (customerAgent.mobilePhoneNumber = $event)
        "
      />
      <hr-field-state-marker
        [field]="field?.mobileNumber"
      ></hr-field-state-marker>
    </div>
  </div>
  <div>
    <div>{{ 'label.MobileNumber' | translate }}2</div>
    <div>
      <input
        maxlength="30"
        type="text"
        [ngModel]="customerAgent && customerAgent.mobilePhoneNumber2"
        (ngModelChange)="
          customerAgent && (customerAgent.mobilePhoneNumber2 = $event)
        "
      />
      <hr-field-state-marker
        [field]="field?.mobileNumber2"
      ></hr-field-state-marker>
    </div>
  </div>
  <div>
    <div>{{ 'label.Position' | translate }}</div>
    <div>
      <input
        maxlength="200"
        minlength="2"
        type="text"
        [ngModel]="customerAgent && customerAgent.position"
        (ngModelChange)="customerAgent && (customerAgent.position = $event)"
      />
      <hr-field-state-marker [field]="field?.position"></hr-field-state-marker>
    </div>
  </div>
  <div>
    <div>{{ 'label.ReceivingEmails' | translate }}</div>
    <div *ngFor="let type of emailTypes" style="width: 220px">
      <span>{{ 'label.' + type.text | translate }} </span
      ><input
        type="checkbox"
        [ngModel]="agentSwitchedOnEmails && agentSwitchedOnEmails[type.value]"
        (ngModelChange)="
          agentSwitchedOnEmails && (agentSwitchedOnEmails[type.value] = $event)
        "
      />
    </div>
  </div>
  <div>
    <div>SMS</div>
    <div *ngFor="let type of smsTypes">
      <div class="sms-type-switch">
        <span>{{ 'label.' + type.name | translate }} </span>
        <input type="checkbox" [(ngModel)]="smsSettings[type.smsTypeId].isOn" />
      </div>

      <select
        [(ngModel)]="smsSettings[type.smsTypeId].reasonId"
        *ngIf="!smsSettings[type.smsTypeId].isOn"
      >
        <option
          *ngFor="let reason of type.stopReasons"
          [ngValue]="reason.smsStopReasonId"
        >
          {{ reason.name }}
        </option>
      </select>
      <br />
      <hr-field-state-marker [field]="field?.reasonId"></hr-field-state-marker>

      <div *ngIf="smsSettings[type.smsTypeId].isOn" class="inline-div">
        <div
          *ngFor="let charset of smsCharsets"
          class="inline-div horizontal-option"
        >
          <input
            type="radio"
            [(ngModel)]="smsSettings[type.smsTypeId].charsetId"
            [value]="charset.value"
            name="charset"
          />{{ charset.text }}
        </div>
      </div>
    </div>
  </div>
  <div>
    <div>{{ 'label.Language' | translate }}</div>
    <label style="margin-right: 5px">
      <input
        type="radio"
        name="Language"
        [value]="primaryLanguage"
        [(ngModel)]="customerAgent.languageId"
      />
      {{ 'label.' + primaryLanguage | translate }}
    </label>
    <label>
      <input
        type="radio"
        name="Language"
        [value]="alternativeLanguage"
        [(ngModel)]="customerAgent.languageId"
      />
      {{ 'label.' + alternativeLanguage | translate }}
    </label>
  </div>
  <div *ngIf="mode == Mode.Edit">
    <div>{{ 'label.Status' | translate }}</div>
    <div>
      <div>{{ customerAgent?.status }}</div>
    </div>
  </div>
  <div
    *ngIf="
      !(currentEditingAgent && currentEditingAgent.isProfileOwner) &&
      mode == Mode.Edit &&
      currentEditingAgent.statusId != 2
    "
  >
    <div>{{ 'label.ProfileOwner' | translate }}</div>
    <div>
      <input type="checkbox" [(ngModel)]="customerAgent.isProfileOwner" />
    </div>
  </div>
  <br />
  <hr-field-state-marker
    [field]="field?.allPhoneNumbers"
  ></hr-field-state-marker>
  <div>
    <div></div>
    <div style="text-align: right">
      <button (click)="onSaveClick()">{{ 'label.Save' | translate }}</button>
      <button (click)="onCancelClick()">
        {{ 'label.Cancel' | translate }}
      </button>
    </div>
  </div>
</div>
